import React from 'react'
import { BodyLayout, GlobalLoading } from '@web/modules/core'

const Fallback = () => (
  <BodyLayout>
    <GlobalLoading />
  </BodyLayout>
)

export default Fallback
